module.exports = __webpack_public_path__ + "static/img/16071B_X_01_2_3_20170801_LC.21366aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16071B_X_01_2_3_20170801_LC.png
// module id = vX3b
// module chunks = 0